module.exports = __webpack_public_path__ + "img/syltech.6eb52853.png";